import React from "react";
import Layout from "../components/Layout/Layout";
import { NavLink } from "react-router-dom";
function Terms() {
  return (
    <Layout title="قوانین و مقررات">
      {/* <!-- Breadcumbs start --> */}
      <div class="e-breadcumb-wrap text-center">
        <h2 class="e-breadcumb-title">قوانین و مقررات</h2>
        <ul class="e-breadcumb-kist">
          <li>
            <NavLink to="/">خانه </NavLink>
          </li>
          <li>
            <NavLink to="/terms">قوانین و مقررات</NavLink>
          </li>
        </ul>
      </div>
      {/* <!-- شرایط و ضوابط start --> */}
      <div class="e-privacy-wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="e-privacy-sec">
                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">ما بازارکده هستیم</h2>
                  <p className="mt-10">
                    یک فروشگاه آنلاین کالا و اجناس عمومی و خاص در سراسر کشور ،
                    که با هدف دسترسی آسوده مصرف کننده به مناسب ترین کالا ها ( چه
                    از نظر کیفیت و چه از نظر قیمت ) راه اندازی شده است. بازارکده
                    علاوه بر فروش کالاهایی که به آسودگی در اختیار عموم قرار دارد
                    ، اقدام به ایجاد بخشی سفارشی ، برای فروش کالاهایی که تنها در
                    لحظه و مخصوص سفارش دهنده ساخته می شود ، کرده است و علاوه بر
                    آن اقدام به فروش محصولات برند های معتبر سراسر دنیا با ضمانت
                    اصالت و سلامت کالا با واردات قانونی پس از سفارش گیری از کشور
                    های همسایه کرده است که به شدت بازارکده را با دیگر فروشگاه
                    های آنلاین متمایز کرده است.
                  </p>
                </div>
                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    پیوستگی بازارکده با شما
                  </h2>
                  <p className="mt-10">
                    در ادامه مطالب شما با شرایط و ضوابط حاکم بر دسترسی و نحوه
                    استفاده از فرشگاه آنلاین بازارکده آشنا خواهید شد. خواهشمند
                    است قبل از عضویت در فروشگاه بازارکده ، این پیوند نامه و کلیه
                    اطلاعات مرتبط دیگری را که در این پیوند نامه به آنها اشاره
                    شده است را با دقت مطالعه نمایید زیرا تمامی مطالب ذکر شده
                    حاکم بر تعامل بازارکده با شما می‌باشد. با ثبت نام و استفاده
                    از بازارکده، شما موافقت خود را با این شرایط و ضوابط اعلام
                    می‌نمایید. در صورت عدم موافقت با شرایط و ضوابط از ثبت نام در
                    این فروشگاه خودداری نمایید.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    قوانین کشوری مرتبط با بازارکده
                  </h2>
                  <p className="mt-10">
                    توجه داشته باشید که کلیه اصول بازارکده منطبق با قوانین
                    جمهوری اسلامی ایران است و متعاقبا کاربر نیز موظف به رعایت
                    قوانین مرتبط با کاربر است. در صورتی که در قوانین مندرج
                    تغییراتی در آینده ایجاد شود، در همین بخش منتشر و به روز
                    رسانی می شود و شما توافق می‏‌کنید که استفاده مستمر شما از
                    فروشگاه به معنی پذیرش هرگونه تغییر است. برخی از این قوانین
                    عبارتند از:
                    <br />
                    <br />
                    قانون تجارت
                    <br />
                    قانون تجارت الکترونیکی
                    <br />
                    قانون مدنی
                    <br />
                    قانون مسئولیت مدنی
                    <br />
                    قانون نظام صنفی کشور
                    <br />
                    قوانین و مقررات مالیاتی
                    <br />
                    قانون جرایم رایانه‌ای
                    <br />
                    قانون حمایت از حقوق مصرف‌کنندگان
                    <br />
                    قانون مبارزه با پولشویی
                    <br />
                    قانون مبارزه با قاچاق کالا و ارز
                    <br />
                    قانون تعزیرات حکومتی
                    <br />
                    قانون مبارزه با مواد مخدر
                    <br />
                    قانون مواد خوردنی و آشامیدنی و آرایشی و بهداشتی
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    آگاهانه های بازارکده
                  </h2>
                  <p className="mt-10">
                    توجه فرمایید که در صورت عدم تعریف واژه‌ای که در این عنوان
                    قید نشده، در چارچوب مقررات، قوانین و عرف تجارت الکترونیکی
                    تفسیر می‌گردد.
                  </p>
                </div>
                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    مشتری یا مصرف کننده
                  </h2>
                  <p className="mt-10">
                    طبق قانون تجارت الکترونیک مشتری یا مصرف کننده هر شخصی است که
                    به منظوری جز تجارت یا شغل حرفه‌ای به خرید کالا یا خدمات
                    اقدام می‌کند و در بازارکده به شخصی گفته می‌شود که با ثبت
                    اطلاعات کاربری خود در مراحل ثبت نام بازارکده، به ثبت سفارش
                    یا هرگونه استفاده از خدمات فروشگاه اقدام می کند.{" "}
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    محصولات فروشگاه بازارکده
                  </h2>
                  <p className="mt-10">
                    محصولات ارایه شده در بازارکده ، یا توسط خود بازارکده از
                    شرکت‌ های معتبر و وارد کنندگان رسمی و قانونی خریداری و عرضه
                    می‌شود و یا برخی فروشندگان با همکاری با بازارکده محصولات خود
                    را به‌واسطه این فروشگاه اینترنتی، به فروش می‌رسانند.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">محصول تقلبی</h2>
                  <p className="mt-10">
                    محصولی غیرقابل قبول است که در کمیت و یا کیفیت و یا نظامات
                    دچار کمبود است. تفاوت در برند یا علائم تجاری، وزن یا مشخصات
                    ظاهری، مدل، بسته‌بندی، استاندارد، گارانتی و ... مصادیقی از
                    نقص کمیت و کیفیت می‌باشد.{" "}
                  </p>
                </div>
                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    پیوند الکترونیکی شما و بازارکده
                  </h2>
                  <p className="mt-10">
                    هرگونه ارتباط و استفاده شما از سرویس‌‏ها و خدمات بازارکده،
                    که بوسیله اینترنت رخ می دهد، به صورت الکترونیکی انجام
                    می‏‌شود و شما موافقت می‌‏کنید که بازارکده نیز به صورت
                    الکترونیکی (از طریق پست الکترونیکی، سرویس پیام کوتاه و سایر
                    سرویس‌های الکترونیکی) به شما پاسخ دهد. همچنین آدرس ایمیل و
                    تلفن‌هایی که مصرف کننده در پروفایل خود ثبت می‌کند، تنها آدرس
                    ایمیل و تلفن‌های رسمی و مورد تایید مشتری برای بازارکده است و
                    تمام مکاتبات و پاسخ‌های شرکت از طریق آنها صورت می‌گیرد.
                    همچنین ما متعهد هستیم فضای الکترونیکی و امکانات دیجیتالی
                    مناسب جهت تعامل با بازارکده را به شما ارائه نماییم. توجه
                    داشته باشید که 22206559(021) و 22206558(021) تنها شماره‌‌
                    هایی است که بازارکده از طریق آن برای کاربران و مشتریان خود
                    پیامک (اس ام اس) ارسال می‌کند. همچنین این شماره‌‌
                    10001994395 سامانه ارسال پیامک است که وضعیت پردازش سفارش یا
                    رویدادها، خدمات و سرویس‌های ویژه بازارکده را به اطلاع
                    کاربران می‌رساند و روشن است که امکان دریافت پیام‌های شما از
                    طریق آن وجود ندارد. بنابراین ارسال هرگونه پیامک تحت عنوان
                    بازارکده ، با هر شماره دیگری تخلف و سوء استفاده از نام
                    بازارکده است و در صورت دریافت چنین پیامکی، لطفاً جهت پیگیری
                    قانونی آن را به Info@bazarkadeh.com اطلاع دهید. به جهت اطلاع
                    ‌رسانی رویدادها، سرویس‌های جدید و ویژه و... امکان دارد
                    بازارکده برای اعضای وب سایت ایمیل یا پیامک ارسال نماید. در
                    صورتی که کاربران تمایل به دریافت اینگونه ایمیل و پیامک‌ها
                    نداشته باشند، می‌توانند تیک عضویت دریافت خبرنامه بازارکده را
                    در پروفایل خود خاموش کنند.{" "}
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    تعهدات حریم خصوصی ( حق و حقوق ) بین بازارکده و شما
                  </h2>
                  <p className="mt-10">
                    حریم خصوصی موضوعی است که باید هم توسط کاربران و هم توسط
                    بازارکده حفظ و مراقبت شود. بازارکده به اطلاعات خصوصی اشخاصى
                    که از خدمات سایت استفاده می‏‌کنند، احترام گذاشته و از آن
                    محافظت می‏‌کند. بازارکده متعهد می‏‌شود در حد توان از حریم
                    شخصی شما دفاع کند و در این راستا، تکنولوژی مورد نیاز برای
                    هرچه مطمئن‏‌تر و امن‏‌تر شدن استفاده شما از سایت را، توسعه
                    دهد. در واقع با استفاده از سایت بازارکده ، شما رضایت خود را
                    از این سیاست نشان می‏‌دهید. باید تاکید شود که حفظ و نگهداری
                    رمز عبور و نام کاربری بر عهده مشتریان است و لذا برای جلوگیری
                    از هرگونه سوءاستفاده احتمالی، مشتریان نباید آن اطلاعات را
                    برای شخص دیگری فاش کنند. در صورتی که مشتری شماره همراه خود
                    را به فردی دیگر واگذار کرد، جهت جلوگیری از سوءاستفاده یا
                    مشکلات احتمالی مشتریان باید شماره موبایل خود در بازارکده را
                    تغییر داده و شماره جدیدی ثبت نمایند. همچنین مسئولیت هرگونه
                    خسارت احتمالی که ناشی از عدم رعایت موارد فوق‌الذکر توسط
                    مشتری باشد، با خود مشتری بوده و مشتری حق هر گونه ادعا علیه
                    بازارکده را از خود سلب می‌کند. بازارکده هویت شخصی کاربران را
                    محرمانه می‌داند و اطلاعات شخصی آنان را به هیچ شخص یا سازمان
                    دیگری منتقل نمی‌کند، مگر اینکه با حکم مقام قضایی یا اداری
                    صالحه یا طبق قوانین و مقررات رایج کشور موظف باشد در اختیار
                    مراجع ذی‌صلاح قرار دهد. در این موارد هیچ گونه مسئولیت قانونی
                    مبنی بر جبران خسارت برای بازارکده وجود ندارد و مشتریان با
                    اعلام رضایت خود در استفاده از خدمات وب سایت ضمنا حق هرگونه
                    اعتراض را از خود سلب نموده اند. بازارکده محصولاتی مناسب
                    استفاده افراد زیر 18 سال نیز به فروش می‏‌رساند و در صورتی که
                    مشتریان از سن ذکر شده جوان‌‏تر هستند می‌‏باید با اطلاع
                    والدین و یا قیَم قانونی، به خرید و پرداخت اقدام کنند.
                    بازارکده ممکن است نقد و نظرات ارسالی مشتریان را در راستای
                    رعایت قوانین وب سایت ویرایش کند. همچنین اگر نظر یا پیام
                    ارسال شده توسط مشتری، مشمول مصادیق محتوای مجرمانه باشد،
                    بازارکده می‌تواند از اطلاعات ثبت ‌شده برای پیگیری قانونی
                    استفاده کند. مشتریان ضمن استفاده از خدمات بازارکده ، حق
                    ویرایش اطلاعات و استفاده از آنها را در چارچوب فوق‌الذکر به
                    بازارکده اعطا نموده و حق اعتراض را از خود سلب می‌نمایند. همه
                    مطالب در دسترس از طریق هر یک از خدمات بازارکده ، مانند متن،
                    گرافیک، آرم، آیکون دکمه، تصاویر، ویدئوهای تصویری، موارد قابل
                    دانلود و کپی، داده‌ها و کلیه محتوای تولید شده توسط بازارکده
                    جزئی از اموال بازارکده محسوب می‏‌شود و حق استفاده و نشر
                    تمامی مطالب موجود و در دسترس در انحصار بازارکده است و هرگونه
                    استفاده بدون کسب مجوز کتبی، حق پیگرد قانونی را برای بازارکده
                    محفوظ می‏‌دارد. علاوه بر این، اسکریپت‌ها، و اسامی خدمات قابل
                    ارائه از طریق هر یک از خدمات ایجاد شده توسط بازارکده و علائم
                    تجاری ثبت شده نیز در انحصار بازارکده است و هر گونه استفاده
                    با مقاصد تجاری پیگرد قانونی دارد. مشتریان مجاز به بهره‌‏
                    برداری و استفاده از لیست محصولات، مشخصات فنی، قیمت و هر گونه
                    استفاده از مشتقات وب ‏‌سایت بازارکده و یا هر یک از خدمات و
                    یا مطالب، دانلود یا کپی کردن اطلاعات با مقاصد تجاری، هر گونه
                    استفاده از داده کاوی، روبات، یا روش‌‏های مشابه مانند جمع
                    آوری داده‌‏ها و ابزارهای استخراج نیستند و کلیه این حقوق به
                    صراحت برای بازارکده محفوظ است. -رعایت این نکات برای حفظ
                    آرامش و امنیت کلیه کاربران در سراسر کشور الزامی می باشد: عدم
                    ثبت نظرات، پرسش‌ها یا پاسخ‌هایی که ماهیت واقعی ندارند، از
                    جمله اظهارنظرهای نژادپرستانه، فحاشی، سوء استفاده از کاربران
                    دیگر، بی‌احترامی به سایر ادیان و فرهنگ‌ها یا اظهارنظرهای
                    تحقیرآمیز و نامناسب دیگر. عدم ثبت اطلاعات یا مطالب ناپسند،
                    ممنوعه یا هرگونه موارد ناشایست. عدم ثبت اطلاعات یا محتوایی
                    که ممکن است دارای محتوا سیاسی توهین‌آمیز یا انتقادی یا مغایر
                    با منافع عمومی باشند. عدم تلاش برای به نتیجه رساندن فروش در
                    خارج از چارچوب معاملات بازارکده عدم دستکاری یا تلاش برای
                    دستکاری bazarkadeh.com به هر روشی. عدم توزیع ویروس، تروجان،
                    کرم، ربات یا سایر فناوری‌های برنامه‌نویسی رایانه‌ای که ممکن
                    است به bazarkadeh.comیا دیگر مشتریان فروشگاه آسیب برساند.
                    عدم تلاش برای ایجاد اختلال در کار فروشگاه بازارکده. عدم تلاش
                    برای تصاحب حساب کاربری دیگر مشتریان ، هک یا فیشینگ فروشگاه
                    یا حساب ‌های کاربری و موارد مربوط به آن عدم کپی، اصلاح یا
                    توزیع محتوای فروشگاه با نقض حق کپی رایت یا علایم تجاری
                    فروشگاه شما موارد ذیل را متعهد شده و ضمانت می‌کنید: - شما 18
                    سال یا بیش از 18 سال سن دارید و یا با اطلاع والدین و یا قیَم
                    قانونی، اقدام به خرید و پرداخت می کنید. - اگر نماینده شرکت
                    هستید، اختیار تام یا تعهد آن شرکت را دارید. - شما هرگونه
                    ارسال اقلام یا معاملاتی که به نظر می رسد مغایر با این توافق
                    نامه است را به بازارکده اطلاع می‌دهید. - شما اطلاعات مربوط
                    به مشتریان موجود در فروشگاه از جمله آدرس ایمیل و سایر
                    اطلاعات تماس را جمع‌آوری نخواهید کرد. - شما هیچ اطلاعات شخصی
                    مشتریان را افشا نمی‌کنید یا در صورت دسترسی به اطلاعات سایر
                    مشتریان از آنها استفاده نمی‌کنید در غیر اینصورت نقض حریم
                    خصوصی بوده و طبق قوانین و مقررات پیگیری خواهد شد. تنها مرجع
                    رسمی مورد تایید ما برای ارتباط با شما، پایگاه رسمی این سایت
                    یعنی www.bazarkadeh.com است. ما با هیچ روش دیگری جز ارسال
                    نامه از طرف آدرس‏‌های رسمی و تایید شده در سایت، با شما تماس
                    نمی‌‏گیریم. وب سایت بازارکده هیچگونه سایت اینترنتی با آدرسی
                    غیر از www. bazarkadeh.com و همچنین، هیچ گونه وبلاگ و شناسه
                    در برنامه‏‌ های گفتگوی اینترنتی همچون Yahoo Messenger یا MSN
                    Messenger و غیره ندارد و هیچ ‏گاه با این روش‏‌ها با شما تماس
                    نمی‏‌گیرد. مشتریان جهت برقراری ارتباط، تنها می‏‌توانند از
                    آدرس‌‏های ذکر شده در بخش ارتباط با ما استفاده کنند. بازارکده
                    در هیچ نقطه‏‌ای از کشور نمایندگی فروش و یا خدمات پس از فروش
                    ندارد و کلیه سرویس‌‏ها و تراکنش‏‌های مالی از طریق دفتر مرکزی
                    پردازش می‏‌شود. لطفاً در صورت مشاهده هر گونه تخلفی از این
                    دست، مراتب را جهت پیگرد قانونی به روابط عمومی بازارکده اطلاع
                    دهید. در حال حاضر بازارکده تنها خدمات ارسال و تحویل سفارش را
                    از طریق مراکز توزیع و پخش خود در تهران انجام می‌دهد و برای
                    خرید تنها باید به فروشگاه اینترنتی بازارکده ( www.
                    bazarkadeh.com ) مراجعه و سفارش خود را ثبت کرد.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    نقد و نظرات شما برای بهبود بازارکده
                  </h2>
                  <p className="mt-10">
                    بازارکده مشتریان را تشویق می‌کند تا پس از اتمام یک سفارش،
                    نقد و نظرات خود را نسبت به تجربه خرید از بازارکده حاصل به
                    اشتراک بگذارند. این اتفاق به تمام مشتریان کمک می‌کند تا از
                    کیفیت کالا و خدمات یک تامین‌کننده مطلع شوند. نقد و نظر مشتری
                    به وسیله نام کاربری یا شماره همراه وی قابلیت ثبت دارد. توجه
                    فرمایید که پس از ثبت یک نقد و نظر، نمی‌توان آن را حذف /
                    ویرایش کرد.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    در هنگام ثبت نقد و نظر در بازارکده به نکات زیر توجه فرمایید
                  </h2>
                  <p className="mt-10">
                    - فارسی بنویسید و از کیبورد فارسی استفاده کنید. بهتر است از
                    فضای خالی (Space) بیش از حد معمول، کشیدن حروف یا کلمات،
                    استفاده‌ی مکرر از یک حرف یا کلمه، شکلک و اموجی در متن
                    خودداری کنید. - برای نظر یا نقد و بررسی خود عنوانی متناسب با
                    متن انتخاب کنید. یک عنوان خوب مشتریان را برای خواندن نظر شما
                    ترغیب خواهد کرد. - نقد مشتریان باید شامل قوت‌ها و ضعف‌های
                    محصول در استفاده‌ی عملی و تجربه‌ی شخصی باشد و مزایا و معایب
                    به‌صورت خلاصه و تیتروار در محل تعیین‌شده درج شود. لازم است
                    تا حد ممکن از مبالغه و بزرگ‌نمایی مزایا یا معایب محصول
                    خودداری کنید. - نقد مناسب، نقدی است که فقط معایب یا فقط
                    مزایا را در نظر نگیرد؛ بلکه به‌طور واقع‌بینانه معایب و
                    مزایای هر محصول را در کنار هم بررسی کند. - با توجه به تفاوت
                    در سطح محصولات مختلف و تفاوت عمده در قیمت‌ های آن‌ها، لازم
                    است نقد و بررسی هر محصول با توجه به قیمت آن صورت گیرد؛ نه
                    به‌صورت مطلق. - جهت احترام‌گذاشتن به وقت بازدیدکنندگان سایت،
                    لازم است هنگام نوشتن نقد، مطالب غیرضروری را حذف کرده و فقط
                    مطالب ضروری و مفید را در نقدتان لحاظ کنید. - با توجه به
                    ساختار بخش نظرات، از سوال‌کردن یا درخواست راهنمایی در این
                    بخش خودداری کرده و سوال یا درخواست راهنمایی خود را در بخش
                    پرسش و پاسخ مطرح کنید. - هنگام نقد موظف ‌اید از ادبیات
                    محترمانه استفاده کرده و از توهین به دیگر مشتریان یا سایر
                    افراد پرهیز کنید. بدیهی است هرگونه توهین به فرد یا افراد ،
                    قوم یا نژاد ، دین و یا فرهنگ ، مباحث جانب دارانه سیاسی و
                    استفاده از کلمات نامناسب، باعث تایید نشدن نظر مشتری می‌شود.
                    - تمام مشتریان حق دارند نظرات خود را به شرط رعایت قوانین، در
                    سایت منتشر کنند؛ لذا حتی اگر نظری را به دور از واقعیت، جانب‌
                    دارانه یا اشتباه یافتید، نباید نظردهنده را مخاطب قرار دهید
                    یا از وی انتقاد کنید. هر مشتری تنها می‌تواند نظر خود را
                    عنوان کرده و قضاوت را به خوانندگان نظرات واگذار کند. - از
                    طریق نمودار تغییر قیمت در سایت می‌توانید از تغییرات قیمت
                    آگاه شوید؛ لذا به ‌هیچ‌ وجه در بخش نظرات مبلغ «قیمت» را ذکر
                    نکرده، درباره‌ی آن سؤال نکنید و نظری ندهید. - توجه کنید که
                    نباید لینک سایت‌ های دیگر را در نظرات خود ثبت کنید. از
                    هرگونه لینک‌ دادن و درج ایمیل یا نام کاربری شبکه‌ های
                    اجتماعی خودداری کنید. -تنها نظراتی تایید خواهند شد که مرتبط
                    با محصول مورد نظر باشند؛ لذا بحث‌ های متفرقه و غیرمرتبط با
                    محصول را مطرح نکنید. - مشتریان می‌توانند نقد خود به هر بخش
                    از بازارکده را در قسمت مربوط اعلام کنند؛ لذا هیچ‌گونه نقدی
                    را درباره‌ی سایت یا خدمات آن در قسمت نظرات ننویسید. - توجه
                    داشته باشند، مسائلی را که از آن اطمینان ندارید، به‌هیچ ‌وجه
                    در نظرات ثبت نکنید؛ همچنین از باز نشر شایعات یا اطلاعات غیر
                    مطمئن درباره‌ی محصولات جدا خودداری کنید. -لازم است نظرات خود
                    را به صورت نگارشی ثبت کرده و از کوتاه‌کردن کلمات یا استفاده
                    از ادبیات محاوره تا جای ممکن خودداری کنید. استفاده از ادبیات
                    نوشتاری که قابلیت نمایش در سایت را داشته باشد، لازمه‌ی تایید
                    نظرات مشتریان است.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    صفر تا صد سفارشات در بازارکده
                  </h2>
                  <p className="mt-10">
                    1) محدودیت سفارش محصولات وارداتی:
                    <br /> - با توجه به این که سفارشات مربوط به بخش محصولات
                    خارجی از طریق واردات از کشور های همسایه به دست شما می رسد
                    لذا فروشگاه بازارکده به منظور ارسال به موقع این محصولات ،
                    قانونی را مبنی بر حداقل خرید برای این دسته از محصولات در نظر
                    نگرفته است. <br /> - با توجه به همین امر که این دسته از
                    محصولات با عبور از مسائل مرزی و وارداتی به دست شما می رسد
                    زمان تحویل این دسته از محصولات بین 10 الی 14 روز متغیر است.
                    2) نکات مربوط به محصولات سفارشی که مخصوص شما ساخته می شوند:{" "}
                    <br /> - با توجه به این نکته که محصولات سفارشی تنها زمانی
                    ساخته می شوند که شما آن ها را درخواست نموده اید بدین ترتیب
                    این محصولات تنها در زمانی امکان بازگشت دارند که یا مطابق
                    سفارش شما نباشند و یا در لحظه تحویل دارای نقص و آسیب دیدگی
                    باشند و در غیر این صورت امکان بازگشتشان وجود ندارد. <br /> -
                    به همین دلیلی که این محصولات در لحظه و پس از سفارش شما ساخته
                    می شوند امکان دارد که زمان تحویل محصول بین 3 تا 10 روز متغیر
                    باشد تا محصول شما به بهترین کیفیت به دست شما برسد. 3) نحوه
                    ارسال سفارشات توسط بازارکده: بازارکده برای ارسال کالا های
                    خود به مشتریان از دو روش کمک می گیرد که یکی از آن ها تنها در
                    شهر تهران اتفاق می افتد. روش اول تحویل اکسپرس است که
                    بازارکده تنها در شهر تهران امکان تحویل اکسپرس را برای
                    مشتریان فراهم کرده است. روش دوم نیز ارسال کالا ها توسط پست
                    پیشتاز است که برای مشتریان ساکن در دیگر شهر های سراسر کشور
                    این امکان فراهم شده است تا با خیالی آسوده اقدام به خریدی امن
                    را از فروشگاه بازارکده تجربه کنند. <br /> - نکته حائز اهمیت
                    این است که ساکنین شهر تهران در هنگام سفارش می توانند انتخاب
                    کنند که نحوه ارسال کالا های آن ها از کدام طریق ( تحویل
                    اکسپرس یا پست پیشتاز) انجام پذیرد. <br /> - هزینه ارسال
                    سفارشات از طریق پست پیشتاز با تعرفه مصوب اداره ی پست محاسبه
                    میشود. <br /> - سفارشات ارسالی با پست پیشتاز طی 4 روز کاری
                    تحویل شما خواهد شد. 4) امکان دریافت حضوری کالا از بازارکده:
                    بازارکده امکان دریافت حضوری کالا در شرکت را ندارد. 5) نحوه
                    تحویل گرفتن سفارشات در شهر تهران (تحویل اکسپرس) : <br /> -
                    لازم به ذکر است نیاز است شما هنگام دریافت سفارش خود از
                    مسئولین ارسال بازارکده کارت شنایی معتبر ارائه دهید که این
                    کارت شناسایی حتما میبایست متعلق به صاحب پروفایل یا شخص تحویل
                    گیرنده باشد، در غیر اینصورت همکاران ما امکان تحویل کالا را
                    نخواهند داشت. - <br />
                    همکاران ما اجازه ورود به ساختمان را ندارند و موظف هستند کالا
                    را درب اصلی منتهی به خیابان تحویل دهند. <br /> - در صورتی که
                    کالای خریداری شده کفش میباشد ، برای تست سایز از دقایقی که
                    هنگام تحویل گرفتن کالا در اختیار دارید، استفاده کنید. <br />{" "}
                    - توجه فرمایید که تطابق تعداد اقلام سفارش با فاکتور، در حضور
                    همکاران تحویل سفارش کنترل شود که در غیر این صورت پذیرفتنی
                    نیست. - تحویل سفارش در اماکن عمومی همچون سینما ، فروشگاه
                    ،کافه، کافی نت، رستوران، هتل و مانند آن امکان‌پذیر نیست و
                    لازم است آدرس تحویل، دقیق و قابل استناد باشد و هنگام ثبت
                    آدرس ، ثبت کد پستی محل دریات سفارشات الزامی می باشد. <br />{" "}
                    - هزینه ارسال سفارشات بالای پانصد هزار تومان در ارسال اکسپرس
                    شهر تهران رایگان و زیر پانصد هزار تومان بسته به حجم و وزن
                    سفارش بین 30000 تا 35000 تومان میباشد. <br /> - تمامی
                    محصولات قبل از ارسال از نظر سلامت چک شده اند در صورت مشاهده
                    هرگونه اشکال یا عدم تطابق فقط تا ۲۴ ساعت امکان مرجوعی وجود
                    دارد 6) نکات و شرایط ثبت سفارشات در فروشگاه بازارکده: <br />{" "}
                    - روز کاری به معنی روز شنبه تا ]چهار شنبه هر هفته، به
                    استثنای تعطیلات عمومی در ایران است و کلیه سفارش‏‌های ثبت شده
                    در طول روزهای کاری و اولین روز پس از تعطیلات پردازش
                    می‌‏شوند. بازارکده به مشتریان خود در ۷ روز هفته و ۲۴ ساعت در
                    روز امکان سفارش‌‏گذاری می‌‏دهد. <br /> - کلیه سفارشات ثبت
                    شده در فروشگاه بازارکده به وسیله یک کد سفارش که از طریق
                    پیامک و پیش فاکتور از طریق ایمیل ارسال می شود ، در صف پردازش
                    قرار می‏‌گیرند. فروشگاه بازارکده همواره در ارسال و تحویل
                    کلیه سفارش‌‏های ثبت شده، نهایت دقت و تلاش خود را انجام
                    می‌دهد. با وجود این ، در صورتی که موجودی محصولی در فروشگاه
                    بازارکده به پایان برسد، حتی پس از اقدام مشتری به
                    سفارش‌‏گذاری، حق کنسل کردن آن سفارش و یا استرداد وجه سفارش
                    برای فروشگاه بازارکده محفوظ است و یا مشتری می‏‌تواند به جای
                    کالای به اتمام رسیده، محصول دیگری را جایگزین کند و یا
                    درخواست بازگشت وجه را بدهد. <br /> - در صورت بروز مشکل در
                    پردازش نهایی سبد خرید مانند اتمام موجودی کالا یا انصراف
                    مشتری ، مبلغ پرداخت شده طی ۴۸ ساعت کاری به حساب مشتری واریز
                    خواهد شد. <br /> - فروشگاه بازارکده مجاز است بدون اطلاع قبلی
                    نسبت به توقف سفارش‌‏گیری جدید، سفارش گیری و فروش خود را
                    متوقف کند و کلیه سفارش ‌‏های ثبت شده قبل از توقف
                    سفارش‌‏گیری، پردازش و ارسال می‌‏شود. حق قطع فروش کلیه و یا
                    بخشی از محصولات به هر دلیلی مانند اتمام موجودی کالا بدون
                    اطلاع قبلی، برای فروشگاه بازارکده محفوظ است. <br /> - در
                    صورت بروز هرگونه خطا نسبت به درج قیمت و ارزش ریالی کالاهای
                    موجود در فروشگاه آنلاین بازارکده ، حق بلا اثر نمودن سفارش و
                    خرید انجام شده توسط مشتری، برای فروشگاه بازارکده محفوظ است.
                    فروشگاه بازارکده در اسرع وقت وجوه دریافتی را به حساب اعلام
                    شده توسط مشتری واریز و عودت می‌نماید و مشتری با ورود به
                    فروشگاه آنلاین بازارکده می‌پذیرد از این امر آگاهی داشته و در
                    این خصوص ادعایی نخواهد داشت. <br /> - مشتریان باید هنگام
                    سفارش کالای مورد نظر خود، فرم سفارش را با اطلاعات صحیح و به
                    طور کامل تکمیل کنند. بدیهی است درصورت ورود اطلاعات ناقص یا
                    نادرست، سفارش مشتری قابل پیگیری و تحویل نخواهد بود. بنابراین
                    درج آدرس(به همراه کد پستی آن)، ایمیل و شماره تماس‌های همراه
                    و ثابت توسط مشتری، به منزله مورد تایید بودن صحت آنها است و
                    در صورتی که این موارد به صورت صحیح یا کامل درج نشده باشد،
                    بازارکده جهت اطمینان از صحت و قطعیت ثبت سفارش می‌تواند از
                    مشتری، اطلاعات تکمیلی و بیشتری درخواست کند. همچنین، مشتریان
                    می‌توانند نام، آدرس و تلفن شخص دیگری را برای تحویل گرفتن
                    سفارش وارد کنند. <br /> - با توجه به ثبت سیستمی سفارش، به
                    هیچ عنوان امکان صدور فاکتور مجدد یا تغییر مشخصات آن از جمله
                    تغییر فاکتوری که به نام شخص حقیقی صادر شده، به نام شخص حقوقی
                    وجود ندارد. همچنین آدرسی که خریدار به عنوان آدرس
                    تحویل‌گیرنده ثبت یا انتخاب می‌کند، در فاکتور درج خواهد شد و
                    لازم است درخواست کنندگان فاکتور به نام شخص حقوقی هنگام ثبت
                    سفارش به این نکته توجه کافی داشته باشند، چرا که تغییر آدرس
                    درج شده روی فاکتور پس از پردازش و تایید سفارش، به هیچ عنوان
                    امکان‌پذیر نخواهد بود. بنابراین لازم است مشتریان هنگام ثبت
                    سفارش، نسبت به این مساله دقت لازم را داشته باشند و اگر نیاز
                    دارند که فاکتور به نام حقوقی برای آنها صادر شود، هنگام ثبت
                    سفارش خود، با انتخاب گزینه ” تکمیل اطلاعات حقوقی ” و وارد
                    کردن مشخصات سازمان مورد نظر، برای خرید سازمانی و دریافت
                    فاکتور رسمی اقدام کنند. - <br />
                    نکته حائز اهمیت اینکه در حال حاضر امکان پرداخت در محل وجود
                    ندارد و لازم است پیش از ارسال، مبلغ سفارش‌ها از طریق پرداخت
                    اینترنتی تسویه شود. <br /> - در صورت خرید اعتباری (استفاده
                    از کد تخفیف) پس از نهایی شدن سبد، از نظر قانونی امکان اعمال
                    تغییر در سبد خرید و تغییر مبلغ فاکتور به دلایل انصراف از
                    خرید ، حذف یا تغییر کالا یا تعداد کالا وجود ندارد و اگر
                    مشتری درخواست هرگونه تغییری را داشته باشد ، کد تخفیف باطل
                    خواهد شد و امکان برگرداندن مبلغ آن وجود ندارد. <br /> - لازم
                    به ذکر است افزودن کالا به سبد خرید به معنی رزرو کالا نیست و
                    هیچ گونه حقی را برای مشتریان ایجاد نمی‌کند. همچنین تا پیش از
                    ثبت نهایی، هرگونه تغییر از جمله تغییر در موجودی کالا یا
                    قیمت، روی کالای افزوده شده به سبد خرید اعمال خواهد شد.
                    بنابراین به مشتریانی که تمایل و تصمیم به خرید قطعی دارند،
                    به‌ویژه درباره کالاهای ارائه شده تحت عنوان شگفت انگیز که
                    دارای محدودیت تعداد هستند، توصیه می‌شود در اسرع وقت سفارش
                    خود را نهایی کنند تا با اتمام موجودی یا تغییر قیمتی کالاها
                    روبرو نشوند. شایان ذکر است سفارش تنها زمانی نهایی می‌شود که
                    مشتریان کد سفارش خود را از طریق پیامک و ایمیل دریافت کنند و
                    بدیهی است که فروشگاه بازارکده هیچ‌گونه مسئولیتی نسبت به
                    کالاهایی که در سبد خرید رها شده است، ندارد. 7) اقدامات
                    بازارکده در صورت تاخیر در تامین کالا ها : در تاریخ تحویل در
                    صورت پیش بینی تاخیر سفارش ، موضوع از طریق پیامک اطلاع رسانی
                    خواهد شد. فروشگاه بازارکده تلاش خواهد کرد سفارشات شما را ظرف
                    24 ساعت تامین کند، درصورت عدم تامین کالا بعد از 24 ساعت ،
                    اقلام در انتظار تامین سفارش شما بصورت سیستمی لغو خواهد شد و
                    همچنین کد تخفیفی برای مشتری لحاظ خواهد شد. 8) شرایط و
                    محدودیت های استفاده از کد تخفیف که معمولا به همراه آن ها
                    بیان خواهد شد: شرایط: <br /> -حداقل مبلغ خرید برای امتیاز
                    گیری 100،000 تومان می باشد . <br /> -شرط استفاده برای کالای
                    خاص تا سقف 100،000 تومان میباشد . -فقط در اولین خرید از
                    بازارکده میتوانید 5% از تخفیف ویژه استفاده نمایید. <br /> -
                    با معرفی سایت بازارکده به دوستان خود 5 امتیاز دریافت خواهید
                    کرد. <br /> - با 500 امتیاز شما میتوانید 5000 تومان تخفیف
                    بگیرید. محدودیت ها: <br /> -شما فقط از هر کد تخفیف یکبار
                    میتوایند استفاده کنید. <br /> -در هر سفارش فقط یک کد تخفیف
                    میتوانید استفاده کنید. <br /> -کد تخفیف برای کالاهای شگفت
                    انگیز و کارت های هدیه بازارکده که در فروشگاه آنلاین بازارکده
                    به بفروش میرسد ، قابل استفاده نیست. <br /> -پس از نهایی شدن
                    سفارش شما امکان تغییر یا اصلاح سفارش را ندارید، در صورت هر
                    گونه تغییر کد تخفیف از بین می رود. <br /> -در صورتی که تاریخ
                    اعتبار آن منقضی شده باشد، امکان استفاده از آن نیست. 9) نکات
                    و شرایط مربوط به بازگشت کالا: <br /> - فروشگاه آنلاین
                    بازارکده برای افزایش سرعت پاسخ گویی به مشتریان با دریافت یک
                    کد سفارش این امکان رو ایجاد کرده که بتونید در زمان کمتری به
                    نتیجه مورد نظر خود برسید. برای این منظور باید قبل از تماس با
                    بازارکده ، از طریق آخرین پیامکی که زمان خرید برای شما ارسال
                    شده ،کد سفارش خودتون رو آماده کنید. <br /> - شما میتوانید
                    درخواست مرجوعی خود را برای وجود اشکال و یا ایراد فنی حداکثر
                    تا 7 روز و برای کالا آسیب دیده حداکثر تا 24 ساعت پس از تحویل
                    کالا به ما اعلام کنید. <br /> - وجود مغایرت، باید حداکثر تا
                    24 ساعت پس از دریافت کالا اطلاع رسانی گردد. - ملاک وجود
                    مغایرت در مشخصات کالا، مشخصات فنی درج شده در وب سایت است.{" "}
                    <br /> - اگر مغایرت، بدون استفاده از کالا قابل مشاهده است،
                    باید کالا در شرایط اولیه باشد و از آن استفاده شده باشد.{" "}
                    <br /> - در صورتی که امکان تشخیص مغایرت تنها با باز کردن
                    بسته بندی ممکن باشد، لازم است کارتن و جعبه اصلی محصولات
                    نگهداری شود و از دور ریختن آن جداً خودداری شود. <br /> - در
                    صورتی که آسیب در لحظه قابل مشاهده باشد، شما میتوانید کالا را
                    تحویل نگیرید . <br /> - استفاده از این سرویس تنها در صورتی
                    امکان‌پذیر است که کالا در کارتن یا جعبه اصلی خود به فروشگاه
                    بازارکده بازگردانده شود. <br /> - لازم است کارتن و جعبه اصلی
                    محصولات تا پایان 7 روز مهلت استفاده، نگهداری شود و از دور
                    ریختن آن جداً خودداری شود. <br /> - لازم است تمامی اقلام
                    همراه محصول را در بسته بندی و شرایط اولیه قرار داده و ارسال
                    نمایید. <br /> - در صورتی که اقلامی به عنوان هدیه در کنار
                    محصول ارسال شده باشد لازم است این اقلام نیز بازگشت داده شود.{" "}
                    <br /> - برچسب‌زدن یا نوشتن توضیحات، و یا پاره و مخدوش کردن
                    کارتن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد.{" "}
                    <br /> - اگر کالا توسط مشتری هرگونه ایرادی پیدا
                    کند(شکستگی-خط و خش) و پس از تحویل کالا در مواردی مانند حمل و
                    نقل و جابجایی و نصب و راه‌اندازی نادرست کالا توسط مشتری
                    آسیبی ببیند شامل این سرویس نمی باشد. <br /> - فروشگاه آنلاین
                    بازارکده همواره نهایت تلاش خود را می‏‌کند تا تمام سفارشات در
                    نهایت صحت و بدون آسیب به دست مشتریان خود در سراسر کشور برسد.
                    با توجه به بسته بندی ایمن و استاندارد همه مرسولات و تحویل به
                    هر یک از شرکت‌‏های حمل و نقل معتبر و اعلام بارنامه مرسوله
                    (درج در سبد خرید و اطلاع رسانی از طریق سرویس پیام کوتاه) به
                    این معنی است که بروز هر گونه حادثه در هنگام حمل و تحویل به
                    عهده شرکت حمل و نقل است و فروشگاه بازارکده تنها در صورت
                    تایید شرکت حمل کننده سفارش و در راستای تسهیل امور پیگیری،
                    خسارت را جبران می‌‏کند. <br /> - آسیب ‏‌های ناشی از حمل و
                    نقل باید حداکثر تا ۲۴ ساعت کاری پس از تحویل سفارش به خدمات
                    پس از فروش فروشگاه بازارکده اطلاع داده شود و کالای آسیب دیده
                    به همراه صورت جلسه رسمی شرکت حمل کننده و کلیه متعلقات و
                    فاکتور به خدمات پس از فروش فروشگاه بازارکده ارسال شود.{" "}
                    <br /> - طی قرارداد بین فروشگاه بازارکده و تامین کنندگان،
                    تاریخ شروع گارانتی بیشتر کالاها، بر اساس تاریخ فاکتور فروش
                    فروشگاه بازارکده محاسبه می‌شود و تاریخ مندرج در برگه گارانتی
                    به تنهایی معیار اعتبار گارانتی نیست. بنابراین اگر کالایی را
                    دریافت کردید که مدتی از تاریخ شروع گارانتی آن گذشته بود جای
                    نگرانی نیست و با ارائه فاکتور فروش خود می‌توانید از خدمات
                    گارانتی کالا استفاده نمایید. - امکان اعلام تاریخ انقضاء مواد
                    خوراکی و لوازم بهداشتی وجود ندارد. - اگر سایز پوشاک یا کفش
                    خریداری شده مناسب نباشد تا 1 روز مهلت تست دارید ، در صورتی
                    که کالا در شرایط اولیه باشد و استفاده نشده باشد، میتواند آن
                    را مرجوع کنید. <br /> - عوارض جسمی و بیماری‌های ناشی از
                    استفاده از کالاهای بهداشتی-مراقبتی ، لوازم بدنسازی و سنجش
                    سلامت برعهده شرکت تولید کننده است. <br /> - در این موارد
                    امکان بازگشت کالا به بازارکده وجود ندارد: لباس های زیر ، گن
                    ، لباس خواب ، لباس بارداری و شیردهی ، جوراب شلواری و ساپورت
                    ، مایو ، لوازم بهداشتی ، زیورآلات( گوشواره و پیرسینگ و کلیه
                    زیور آلات طلا) ، لوازم آرایشی (در صورت باز شدن پلمپ کالا) و
                    کارت های هدیه بازارکده 10) هدیه دعوت از دوستانتان به فروشگاه
                    بازارکده: شما به ازای 10 نفر اولی که به بازارکده دعوت کرده
                    اید، هدیه دریافت میکنید. اما دعوت از دوستان محدودیتی ندارد.
                    کد تخفیفی که در بخش دعوت از دوستان وجود دارد برای دعوت آنان
                    به فروشگاه بازارکده ساخته شده است. شما میتوانید این کد را
                    برای دوستانی که عضو بازارکده نیستند ارسال کنید تا 5 امتیاز
                    به شما تعلق بگیرد.
                  </p>
                </div>

                <div class="e-privacy-box mb-30">
                  <h2 class="cmn-brdr-ttle big-ttl mb-10">
                    قوه قاهره ( شرایط فورس ماژور )
                  </h2>
                  <p className="mt-10">
                    تمامی شرایط و قوانین مندرج، در شرایط عادی قابل اجرا است و در
                    صورت بروز هرگونه از موارد قوه قاهره، بازارکده هیچ گونه
                    مسئولیتی ندارد. قوه قهریه یا قوه قاهره یا فورس ماژور به
                    فرانسوی: (Force majeure ( اصطلاحی در حقوق فرانسه است که
                    ظاهراً نخستین بار در قانون مدنی فرانسه «کد ناپلئون» به کار
                    رفته و سپس در کشورهای دیگر، همین اصطلاح، حتی در حقوق و
                    کتاب‌های متعدد، مورد استفاده قرارگرفته و رایج شده است. در
                    حقوق فرانسه، فورس ماژور دارای معنی عام و معنی خاص است. فورس
                    ماژور به معنی عام، عبارت است از هر حادثه خارجی «خارج از حیطه
                    قدرت متعهد» غیرقابل پیش‌بینی و غیرقابل اجتناب، که مانع اجرای
                    تعهد باشد. فورس ماژور، بدین معنی، شامل عمل شخص ثالث و عمل
                    متعهدلَه که واحد در صفت مذکور باشند نیز خواهد شد. اما فورس
                    ماژور، به معنی خاص، حادثه‌ای است ناشی از نیروهای طبیعی،
                    غیرقابل پیش‌بینی و غیرقابل اجتناب.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Terms;
